import { Field, Form } from 'react-final-form'

import { showErrorToast } from 'common/api/helpers'
import Button from 'common/components/button'
import FormItem from 'common/components/formItem'
import Modal from 'common/components/Modal'
import Textarea from 'common/components/textarea'
import {
  replaceLineBreakAsNewLineEmoji,
  replaceNewLineEmojiAsElement,
  replaceNewLineEmojiAsString,
} from 'common/variantsUtils'

const EditModal = ({ isOpen, variantText, onClose, onEdit }) => {
  const handleEdit = async (formValues) => {
    const { updatedVariantText } = formValues
    const parsedVariantText = replaceLineBreakAsNewLineEmoji(updatedVariantText)

    try {
      await onEdit(parsedVariantText)
      onClose()
    } catch (error) {
      showErrorToast('Something went wrong. Please try again.')
    }
  }

  return (
    <Form
      onSubmit={handleEdit}
      destroyOnUnregister
      render={({
        handleSubmit,
        pristine,
        hasValidationErrors,
        submitting,
        form,
      }) => (
        <Modal
          visible={isOpen}
          centered
          data-testid="edit-core-variant-modal"
          bodyStyle={{
            minWidth: '600px',
          }}
          closable={false}
          footer={
            <div className="flex">
              <Button
                data-testid="cancel-edit-variant-button"
                variant="link"
                onClick={() => {
                  form.reset()
                  onClose()
                }}
                disabled={submitting}
              >
                Cancel
              </Button>
              <Button
                className="ml-4"
                data-testid="edit-variant-button"
                variant="primary"
                onClick={handleSubmit}
                disabled={pristine || hasValidationErrors}
                loading={submitting}
              >
                Edit
              </Button>
            </div>
          }
        >
          <form className="flex flex-col" onSubmit={handleSubmit}>
            <p className=" text-base-700 mb-2">Making a change to:</p>
            <div className="px-6 py-3 bg-gold-100 mb-10">
              {replaceNewLineEmojiAsElement(variantText)}
            </div>
            <p className=" text-base-700 mb-2">Make your edits here:</p>
            <Field<string>
              name="updatedVariantText"
              initialValue={replaceNewLineEmojiAsString(variantText)}
              validate={(value) => {
                if (!value || value.trim() === '') {
                  return 'This field cannot be empty'
                }
              }}
              render={({ input, meta }) => (
                <FormItem htmlFor="updatedVariantText" error={meta.error}>
                  <Textarea rows={4} {...input} />
                </FormItem>
              )}
            />
          </form>
        </Modal>
      )}
    />
  )
}

export default EditModal
